import React from "react";

const shouldContentBeReEvaluated = (contentFound, variationType) =>
  typeof contentFound === "object" &&
  !Array.isArray(contentFound) &&
  !React.isValidElement(contentFound) &&
  contentFound.hasOwnProperty(variationType);

export const NoVariationTypeToMatchOn = "No content variation to match on";
export const ContentNotFoundMessage = "Content not found";
export const NoContentToProcess = "No content injected to process";
export const ContentFoundTooComplexMessage =
  "Content was found, but deemed too complex. Consider moving complexity out of content";

export function getContentByVariationType(variationType, contentToProcess) {
  if (!variationType) {
    return NoVariationTypeToMatchOn;
  }
  if (!contentToProcess) {
    return NoContentToProcess;
  }
  if (typeof contentToProcess === "string") {
    return contentToProcess;
  }
  if (contentToProcess.hasOwnProperty(variationType)) {
    let contentFound = contentToProcess[variationType];

    if (shouldContentBeReEvaluated(contentFound, variationType)) {
      contentFound = getContentByVariationType(variationType, contentFound);
    }

    if (Array.isArray(contentFound)) {
      return ContentFoundTooComplexMessage;
    }

    return contentFound;
  }
  return ContentNotFoundMessage;
}

export default {
  getContentByVariationType
};
